import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'orderBy'})
export class OrderBy implements PipeTransform {

 transform(input:any, args:string[]) : any {
   //transform input somehow
   return input;
 }
}


// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/pipe/orderby.pipe.ts